import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { take } from 'rxjs';

import { DecreeActionTypeService } from '~/repositories/meeting/services/decree-action-type.service';
import { MeetingItem } from '~/repositories/meeting/store/meeting.models';
import { MenuItemType } from '~/ui/detail/detail-action-button/detail-action-buttons.const';
import { MenuItem, MenuItemTypeConfiguration } from '~/ui/detail/detail-action-button/detail-action-buttons.types';

@Component({
  selector: 'app-detail-action-button-toggle',
  templateUrl: './detail-action-button-toggle.component.html',
  styleUrl: './detail-action-button-toggle.component.scss',
  standalone: false
})
export class DetailActionButtonToggleComponent implements OnInit, OnChanges {
  @Input() item: MenuItem;
  @Input() checkedItems: MeetingItem[] = [];
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() endAction = new EventEmitter<boolean>();

  dialogVisible = false;
  config: MenuItemTypeConfiguration<MenuItemType.TOGGLE>;
  filteredMeetingItemIds: string[] = [];

  constructor(private decreeActionTypeService: DecreeActionTypeService) {}

  ngOnInit() {
    this.config = this.item as MenuItemTypeConfiguration<MenuItemType.TOGGLE>;
  }

  ngOnChanges() {
    if (this.checkedItems) {
      this.filteredMeetingItemIds = this.checkedItems
        ?.filter((item) => item.type === 'AGENDAPAGE')
        .map((item) => item.id ?? item.key);
    }
  }

  handleToggle() {
    if (this.filteredMeetingItemIds?.length === 0) {
      return;
    }
    this.decreeActionTypeService
      .toggleDetailAction(this.filteredMeetingItemIds, this.config?.typeOptions?.url)
      .pipe(take(1))
      .subscribe();

    this.endAction.emit();
  }

  handleShowDialog() {
    this.dialogVisible = true;
  }

  protected readonly MenuItemType = MenuItemType;
}
